import { ref, watch, type Ref } from "vue";

export function useToggleEditableItem({ allExpanded }: { allExpanded: Ref<boolean> }) {
    const isOpen = ref(false);

    function toggleOpen(value: boolean) {
        isOpen.value = value;
    }

    watch(
        () => allExpanded.value,
        newValue => {
            isOpen.value = newValue;
        },
        { immediate: true }
    );

    return {
        isOpen,
        toggleOpen
    };
}
